let app

module.exports = {
    setApp: (appp) => {
        app = appp
    },
    "title": "Email",
    "entityName": "email",
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    // "select": ["id", "account", "to", "cc", "bcc", "insert_at", "sent_at", "subject", "status"],
    "fields": [
        {
            "value": "account_id",
            "text": "Account",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            render: (item) => {
                return item.account.first_name + ' ' + (item.account.last_name || '')
            },
            filter: (item, search) => {
                if (search) return { urs : [{ 'first_name': `%${search}%`}, { 'last_name': `%${search}%`}]}
            },

        },
        {
            "value": "to",
            "text": "Recipients",
            "type": "text",
            "table": {
                "filter": true
            },
            render: (item) => {
                let aCount = 0
                let bCount = 0
                let cCount = 0
                if(item.to) {
                    aCount = item.to.length
                }
                if(item.cc) {
                    bCount = item.cc.length
                }
                if(item.bcc) {
                    cCount = item.bcc.length
                }
                return `To:${aCount}  Cc:${bCount}  Bcc:${cCount}`
            },
            filter: (item, search) => {
                if (search) return [{ 'to': `%${search}%`}, { 'cc': `%${search}%`}, { 'bcc': `%${search}%`}]
            },
            tooltip: (item) => {
                let a = (item.to || '') + "\n" + (item.cc || '') + "\n" + (item.bcc || '')
                return a.replaceAll(',', "\n")
            }

        },
        {
            "value": "subject",
            "text": "Subject",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            filter: (item, search) => {
                if (search) return { 'subject': `%${search}%`}
            },
        },
        {
            "value": "status",
            "text": "Status",
            "type": "list",
            render: (item) => {

                if (item.status == 'read') {
                    return "<font style='color:green'><b>READ</b></font><br> First : " +  item.read_at[0] + (item.read_at.length > 1 ? " <br> Last : " + item.read_at[item.read_at.length - 1] : '')
                }

                if (item.status == 'sent') {
                    return "<font style='color:blue'><b>SENT</b></font><br>" + item.sent_at
                }

                if (item.status == 'queued') {
                    return "<font style='color:orange'><b>QUEUED</b></font><br>" + item.insert_at
                }

                if (item.status == 'error') {
                    return "<font style='color:red'><b>ERROR</b></font><br>" + item.insert_at
                }

            },
            tooltip: (item) => {
                return item.status == 'error' ? item.error : null
            },
            click: (item) => {
                navigator.clipboard.writeText(item.error)
                app.clicked(item)
            },
            "table": {
                "sortable": true,
                "filter": true
            },
            list: ['queued', 'sent', 'read', 'error']
        },


    ],
    "actions": [
        { "value": "read", "text": "View", "icon": "mdi-eye", "color": "primary" }
    ]
}